export const grade10Part5 = [
  {
    id: 'g10-3d-geometry-volume',
    title: 'Volume and Surface Area of 3D Solids',
    topic: '3D Geometry',
    standard: 'CCSS.MATH.CONTENT.HSG.GMD.A.3',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'What is the volume of a cylinder with radius 5 cm and height 12 cm?',
        options: ['300π cm³', '120π cm³', '60π cm³', '150π cm³'],
        correctAnswer: 0,
        solution: 'Volume of cylinder: V = πr²h\n\nV = π(5²)(12)\nV = π(25)(12)\nV = 300π cm³\n\nApproximately: 300π ≈ 942.5 cm³'
      },
      {
        id: 2,
        question: 'A cone has radius 6 cm and height 8 cm. What is its volume?',
        options: ['96π cm³', '288π cm³', '144π cm³', '48π cm³'],
        correctAnswer: 0,
        solution: 'Volume of cone: V = (1/3)πr²h\n\nV = (1/3)π(6²)(8)\nV = (1/3)π(36)(8)\nV = (1/3)(288π)\nV = 96π cm³\n\nCone volume is 1/3 of cylinder volume.'
      },
      {
        id: 3,
        question: 'What is the surface area of a sphere with radius 3 cm?',
        options: ['36π cm²', '12π cm²', '9π cm²', '108π cm²'],
        correctAnswer: 0,
        solution: 'Surface area of sphere: SA = 4πr²\n\nSA = 4π(3²)\nSA = 4π(9)\nSA = 36π cm²\n\nApproximately: 36π ≈ 113.1 cm²'
      },
      {
        id: 4,
        question: 'A rectangular prism has dimensions 4 cm × 5 cm × 6 cm. What is its volume?',
        options: ['120 cm³', '74 cm³', '148 cm³', '60 cm³'],
        correctAnswer: 0,
        solution: 'Volume of rectangular prism: V = lwh\n\nV = 4 × 5 × 6\nV = 120 cm³\n\nMultiply length × width × height.'
      },
      {
        id: 5,
        question: 'What is the volume of a sphere with radius 6 cm?',
        options: ['288π cm³', '144π cm³', '864π cm³', '216π cm³'],
        correctAnswer: 0,
        solution: 'Volume of sphere: V = (4/3)πr³\n\nV = (4/3)π(6³)\nV = (4/3)π(216)\nV = (4/3)(216π)\nV = 288π cm³\n\nApproximately: 288π ≈ 904.8 cm³'
      },
      {
        id: 6,
        question: 'A pyramid has a square base with side 8 cm and height 9 cm. What is its volume?',
        options: ['192 cm³', '576 cm³', '288 cm³', '64 cm³'],
        correctAnswer: 0,
        solution: 'Volume of pyramid: V = (1/3)Bh\nwhere B = area of base\n\nBase area: B = 8² = 64 cm²\nV = (1/3)(64)(9)\nV = (1/3)(576)\nV = 192 cm³\n\nPyramid volume is 1/3 of prism volume.'
      },
      {
        id: 7,
        question: 'What is the surface area of a cube with edge length 5 cm?',
        options: ['150 cm²', '125 cm²', '75 cm²', '25 cm²'],
        correctAnswer: 0,
        solution: 'Surface area of cube: SA = 6s²\n\nSA = 6(5²)\nSA = 6(25)\nSA = 150 cm²\n\nA cube has 6 congruent square faces.'
      },
      {
        id: 8,
        question: 'A cylinder has volume 200π cm³ and radius 5 cm. What is its height?',
        options: ['8 cm', '10 cm', '40 cm', '4 cm'],
        correctAnswer: 0,
        solution: 'Volume of cylinder: V = πr²h\n\n200π = π(5²)h\n200π = 25πh\n200 = 25h\nh = 8 cm\n\nDivide volume by πr² to find height.'
      },
      {
        id: 9,
        question: 'What is the lateral surface area of a cylinder with radius 4 cm and height 10 cm?',
        options: ['80π cm²', '160π cm²', '40π cm²', '32π cm²'],
        correctAnswer: 0,
        solution: 'Lateral surface area of cylinder: LSA = 2πrh\n(excludes top and bottom circles)\n\nLSA = 2π(4)(10)\nLSA = 80π cm²\n\nThis is the area of the curved surface only.'
      },
      {
        id: 10,
        question: 'A cone and a cylinder have the same radius and height. How do their volumes compare?',
        options: ['Cone volume = (1/3) × cylinder volume', 'Cone volume = cylinder volume', 'Cone volume = (1/2) × cylinder volume', 'Cone volume = 2 × cylinder volume'],
        correctAnswer: 0,
        solution: 'Cylinder: V = πr²h\nCone: V = (1/3)πr²h\n\nRatio: Cone/Cylinder = (1/3)πr²h / πr²h = 1/3\n\nCone volume is always 1/3 of cylinder volume with same base and height.'
      },
      {
        id: 11,
        question: 'What is the volume of a rectangular prism with length 10 cm, width 6 cm, and height 4 cm?',
        options: ['240 cm³', '120 cm³', '160 cm³', '80 cm³'],
        correctAnswer: 0,
        solution: 'Volume: V = lwh\n\nV = 10 × 6 × 4\nV = 240 cm³\n\nMultiply all three dimensions.'
      },
      {
        id: 12,
        question: 'A sphere has volume 36π cm³. What is its radius?',
        options: ['3 cm', '6 cm', '9 cm', '2 cm'],
        correctAnswer: 0,
        solution: 'Volume of sphere: V = (4/3)πr³\n\n36π = (4/3)πr³\n36 = (4/3)r³\n108 = 4r³\n27 = r³\nr = 3 cm\n\nTake the cube root to find radius.'
      },
      {
        id: 13,
        question: 'What is the total surface area of a cylinder with radius 3 cm and height 8 cm?',
        options: ['66π cm²', '48π cm²', '24π cm²', '72π cm²'],
        correctAnswer: 0,
        solution: 'Total surface area: SA = 2πr² + 2πrh\n(two circles + lateral surface)\n\nSA = 2π(3²) + 2π(3)(8)\nSA = 2π(9) + 2π(24)\nSA = 18π + 48π\nSA = 66π cm²'
      },
      {
        id: 14,
        question: 'A cone has slant height 13 cm and radius 5 cm. What is its lateral surface area?',
        options: ['65π cm²', '130π cm²', '25π cm²', '169π cm²'],
        correctAnswer: 0,
        solution: 'Lateral surface area of cone: LSA = πrl\nwhere l = slant height\n\nLSA = π(5)(13)\nLSA = 65π cm²\n\nThis is the area of the curved surface only.'
      },
      {
        id: 15,
        question: 'If a cube has volume 64 cm³, what is its edge length?',
        options: ['4 cm', '8 cm', '16 cm', '2 cm'],
        correctAnswer: 0,
        solution: 'Volume of cube: V = s³\n\n64 = s³\ns = ∛64\ns = 4 cm\n\nTake the cube root of the volume.'
      },
      {
        id: 16,
        question: 'What is the volume of a cone with diameter 12 cm and height 10 cm?',
        options: ['120π cm³', '360π cm³', '240π cm³', '480π cm³'],
        correctAnswer: 0,
        solution: 'Diameter = 12 cm, so radius = 6 cm\n\nVolume of cone: V = (1/3)πr²h\n\nV = (1/3)π(6²)(10)\nV = (1/3)π(36)(10)\nV = (1/3)(360π)\nV = 120π cm³'
      },
      {
        id: 17,
        question: 'A pyramid has a rectangular base 6 cm × 8 cm and height 12 cm. What is its volume?',
        options: ['192 cm³', '576 cm³', '288 cm³', '384 cm³'],
        correctAnswer: 0,
        solution: 'Volume of pyramid: V = (1/3)Bh\n\nBase area: B = 6 × 8 = 48 cm²\nV = (1/3)(48)(12)\nV = (1/3)(576)\nV = 192 cm³'
      },
      {
        id: 18,
        question: 'What is the surface area of a rectangular prism with dimensions 3 cm × 4 cm × 5 cm?',
        options: ['94 cm²', '60 cm²', '47 cm²', '120 cm²'],
        correctAnswer: 0,
        solution: 'Surface area: SA = 2(lw + lh + wh)\n\nSA = 2(3×4 + 3×5 + 4×5)\nSA = 2(12 + 15 + 20)\nSA = 2(47)\nSA = 94 cm²\n\nSum of areas of all 6 faces.'
      },
      {
        id: 19,
        question: 'A cylinder has radius 7 cm and height 10 cm. What is its volume?',
        options: ['490π cm³', '140π cm³', '700π cm³', '245π cm³'],
        correctAnswer: 0,
        solution: 'Volume of cylinder: V = πr²h\n\nV = π(7²)(10)\nV = π(49)(10)\nV = 490π cm³\n\nApproximately: 490π ≈ 1539.4 cm³'
      },
      {
        id: 20,
        question: 'If the radius of a sphere is doubled, by what factor does its volume increase?',
        options: ['8', '2', '4', '16'],
        correctAnswer: 0,
        solution: 'Original volume: V₁ = (4/3)πr³\nNew volume: V₂ = (4/3)π(2r)³ = (4/3)π(8r³) = 8 × (4/3)πr³\n\nV₂ = 8V₁\n\nVolume increases by factor of 8 (2³ = 8)\n\nVolume scales with the cube of the radius.'
      },
      {
        id: 21,
        question: 'What is the volume of a hemisphere with radius 6 cm?',
        options: ['144π cm³', '288π cm³', '72π cm³', '216π cm³'],
        correctAnswer: 0,
        solution: 'Hemisphere = half of sphere\n\nVolume of sphere: V = (4/3)πr³\nVolume of hemisphere: V = (1/2) × (4/3)πr³ = (2/3)πr³\n\nV = (2/3)π(6³)\nV = (2/3)π(216)\nV = 144π cm³'
      },
      {
        id: 22,
        question: 'A cone has volume 100π cm³ and height 12 cm. What is its radius?',
        options: ['5 cm', '10 cm', '25 cm', '15 cm'],
        correctAnswer: 0,
        solution: 'Volume of cone: V = (1/3)πr²h\n\n100π = (1/3)πr²(12)\n100π = 4πr²\n100 = 4r²\n25 = r²\nr = 5 cm'
      },
      {
        id: 23,
        question: 'What is the lateral surface area of a cone with radius 8 cm and height 15 cm?',
        options: ['136π cm²', '120π cm²', '272π cm²', '64π cm²'],
        correctAnswer: 0,
        solution: 'First find slant height: l = √(r² + h²)\nl = √(8² + 15²) = √(64 + 225) = √289 = 17 cm\n\nLateral surface area: LSA = πrl\nLSA = π(8)(17)\nLSA = 136π cm²'
      },
      {
        id: 24,
        question: 'A cube has surface area 96 cm². What is its volume?',
        options: ['64 cm³', '16 cm³', '256 cm³', '32 cm³'],
        correctAnswer: 0,
        solution: 'Surface area of cube: SA = 6s²\n\n96 = 6s²\n16 = s²\ns = 4 cm\n\nVolume: V = s³ = 4³ = 64 cm³'
      },
      {
        id: 25,
        question: 'What is the volume of a cylinder with circumference 10π cm and height 8 cm?',
        options: ['200π cm³', '80π cm³', '400π cm³', '160π cm³'],
        correctAnswer: 0,
        solution: 'Circumference: C = 2πr = 10π\n2πr = 10π\nr = 5 cm\n\nVolume: V = πr²h\nV = π(5²)(8)\nV = π(25)(8)\nV = 200π cm³'
      },
      {
        id: 26,
        question: 'A square pyramid has base edge 10 cm and slant height 13 cm. What is its lateral surface area?',
        options: ['260 cm²', '520 cm²', '130 cm²', '100 cm²'],
        correctAnswer: 0,
        solution: 'Lateral surface area = 4 triangular faces\n\nArea of one triangle = (1/2) × base × slant height\n= (1/2) × 10 × 13 = 65 cm²\n\nTotal LSA = 4 × 65 = 260 cm²'
      },
      {
        id: 27,
        question: 'If the height of a cylinder is tripled while the radius stays the same, by what factor does the volume increase?',
        options: ['3', '9', '6', '27'],
        correctAnswer: 0,
        solution: 'Original volume: V₁ = πr²h\nNew volume: V₂ = πr²(3h) = 3πr²h\n\nV₂ = 3V₁\n\nVolume increases by factor of 3.\n\nVolume is directly proportional to height.'
      },
      {
        id: 28,
        question: 'What is the volume of a triangular prism with base area 20 cm² and height 15 cm?',
        options: ['300 cm³', '150 cm³', '600 cm³', '100 cm³'],
        correctAnswer: 0,
        solution: 'Volume of prism: V = Bh\nwhere B = base area\n\nV = 20 × 15\nV = 300 cm³\n\nMultiply base area by height.'
      },
      {
        id: 29,
        question: 'A sphere and a cylinder have the same radius r and the cylinder has height 2r. How do their volumes compare?',
        options: ['Sphere volume = (2/3) × cylinder volume', 'Sphere volume = cylinder volume', 'Sphere volume = (1/2) × cylinder volume', 'Sphere volume = (4/3) × cylinder volume'],
        correctAnswer: 0,
        solution: 'Sphere: V_s = (4/3)πr³\nCylinder: V_c = πr²(2r) = 2πr³\n\nRatio: V_s/V_c = (4/3)πr³ / 2πr³ = (4/3) / 2 = 4/6 = 2/3\n\nSphere volume = (2/3) × cylinder volume'
      },
      {
        id: 30,
        question: 'What is the total surface area of a cone with radius 5 cm and slant height 13 cm?',
        options: ['90π cm²', '65π cm²', '155π cm²', '25π cm²'],
        correctAnswer: 0,
        solution: 'Total surface area = base + lateral surface\n\nBase area: πr² = π(5²) = 25π cm²\nLateral area: πrl = π(5)(13) = 65π cm²\n\nTotal SA = 25π + 65π = 90π cm²'
      }
    ]
  },
  {
    id: 'g10-coordinate-geometry',
    title: 'Coordinate Geometry and Distance Formula',
    topic: 'Coordinate Geometry',
    standard: 'CCSS.MATH.CONTENT.HSG.GPE.B.7',
    difficulty: 'medium',
    questions: [
      {
        id: 1,
        question: 'What is the distance between points A(3, 4) and B(7, 1)?',
        options: ['5', '7', '√7', '√41'],
        correctAnswer: 0,
        solution: 'Distance formula: d = √[(x₂-x₁)² + (y₂-y₁)²]\n\nd = √[(7-3)² + (1-4)²]\nd = √[4² + (-3)²]\nd = √[16 + 9]\nd = √25\nd = 5'
      },
      {
        id: 2,
        question: 'What is the midpoint of the segment connecting (2, 5) and (8, -3)?',
        options: ['(5, 1)', '(10, 2)', '(6, 2)', '(5, 4)'],
        correctAnswer: 0,
        solution: 'Midpoint formula: M = ((x₁+x₂)/2, (y₁+y₂)/2)\n\nM = ((2+8)/2, (5+(-3))/2)\nM = (10/2, 2/2)\nM = (5, 1)\n\nAverage the x-coordinates and y-coordinates.'
      },
      {
        id: 3,
        question: 'What is the slope of the line passing through (1, 3) and (5, 11)?',
        options: ['2', '1/2', '8', '4'],
        correctAnswer: 0,
        solution: 'Slope formula: m = (y₂-y₁)/(x₂-x₁)\n\nm = (11-3)/(5-1)\nm = 8/4\nm = 2\n\nThe slope is 2 (rise over run).'
      },
      {
        id: 4,
        question: 'What is the equation of a circle with center (2, -3) and radius 4?',
        options: ['(x-2)² + (y+3)² = 16', '(x+2)² + (y-3)² = 16', '(x-2)² + (y+3)² = 4', '(x+2)² + (y-3)² = 4'],
        correctAnswer: 0,
        solution: 'Circle equation: (x-h)² + (y-k)² = r²\n\nCenter: (h, k) = (2, -3)\nRadius: r = 4\n\n(x-2)² + (y-(-3))² = 4²\n(x-2)² + (y+3)² = 16'
      },
      {
        id: 5,
        question: 'Two lines are perpendicular. If one has slope 3, what is the slope of the other?',
        options: ['-1/3', '3', '1/3', '-3'],
        correctAnswer: 0,
        solution: 'Perpendicular slopes are negative reciprocals.\n\nIf m₁ = 3, then m₂ = -1/m₁\n\nm₂ = -1/3\n\nProduct of perpendicular slopes: m₁ × m₂ = -1'
      },
      {
        id: 6,
        question: 'What is the distance from point (4, 3) to the origin?',
        options: ['5', '7', '√7', '1'],
        correctAnswer: 0,
        solution: 'Origin is at (0, 0)\n\nDistance: d = √[(4-0)² + (3-0)²]\nd = √[16 + 9]\nd = √25\nd = 5\n\nThis forms a 3-4-5 right triangle.'
      },
      {
        id: 7,
        question: 'What is the slope of a horizontal line?',
        options: ['0', '1', 'Undefined', '-1'],
        correctAnswer: 0,
        solution: 'Horizontal line: y = constant\n\nAll points have same y-coordinate.\n\nSlope: m = (y₂-y₁)/(x₂-x₁) = 0/(x₂-x₁) = 0\n\nHorizontal lines have slope 0.'
      },
      {
        id: 8,
        question: 'What is the slope of a vertical line?',
        options: ['Undefined', '0', '1', 'Infinite'],
        correctAnswer: 0,
        solution: 'Vertical line: x = constant\n\nAll points have same x-coordinate.\n\nSlope: m = (y₂-y₁)/(x₂-x₁) = (y₂-y₁)/0 = undefined\n\nVertical lines have undefined slope (division by zero).'
      },
      {
        id: 9,
        question: 'Points A(1, 2), B(4, 6), and C(7, 10) are collinear. What is the slope of line AC?',
        options: ['4/3', '3/4', '2', '8/6'],
        correctAnswer: 0,
        solution: 'Slope of AC: m = (10-2)/(7-1) = 8/6 = 4/3\n\nVerify with AB: m = (6-2)/(4-1) = 4/3 ✓\n\nCollinear points have the same slope between any two points.'
      },
      {
        id: 10,
        question: 'What is the equation of a line with slope 2 passing through (3, 5)?',
        options: ['y = 2x - 1', 'y = 2x + 5', 'y = 2x + 3', 'y = 2x - 11'],
        correctAnswer: 0,
        solution: 'Point-slope form: y - y₁ = m(x - x₁)\n\ny - 5 = 2(x - 3)\ny - 5 = 2x - 6\ny = 2x - 1\n\nSlope-intercept form: y = 2x - 1'
      },
      {
        id: 11,
        question: 'Two parallel lines have slopes m₁ and m₂. What is true about m₁ and m₂?',
        options: ['m₁ = m₂', 'm₁ × m₂ = -1', 'm₁ + m₂ = 0', 'm₁ = -m₂'],
        correctAnswer: 0,
        solution: 'Parallel lines have equal slopes.\n\nm₁ = m₂\n\nParallel lines never intersect and have the same steepness.'
      },
      {
        id: 12,
        question: 'What is the center of the circle x² + y² - 6x + 4y - 12 = 0?',
        options: ['(3, -2)', '(-3, 2)', '(6, -4)', '(-6, 4)'],
        correctAnswer: 0,
        solution: 'Complete the square:\nx² - 6x + y² + 4y = 12\n\n(x² - 6x + 9) + (y² + 4y + 4) = 12 + 9 + 4\n(x - 3)² + (y + 2)² = 25\n\nCenter: (3, -2)\nRadius: 5'
      },
      {
        id: 13,
        question: 'What is the distance between parallel lines y = 2x + 1 and y = 2x + 7?',
        options: ['6/√5', '6', '√5', '6√5'],
        correctAnswer: 0,
        solution: 'Distance between parallel lines ax + by + c₁ = 0 and ax + by + c₂ = 0:\nd = |c₂ - c₁|/√(a² + b²)\n\nRewrite: 2x - y + 1 = 0 and 2x - y + 7 = 0\n\nd = |7 - 1|/√(2² + (-1)²)\nd = 6/√5\nd = 6√5/5'
      },
      {
        id: 14,
        question: 'Point P divides segment AB in ratio 2:3. If A(1, 2) and B(6, 12), what are the coordinates of P?',
        options: ['(3, 6)', '(4, 8)', '(2, 4)', '(5, 10)'],
        correctAnswer: 0,
        solution: 'Section formula: P = ((m·x₂ + n·x₁)/(m+n), (m·y₂ + n·y₁)/(m+n))\nwhere ratio is m:n\n\nRatio 2:3 from A to B:\nP = ((2·6 + 3·1)/(2+3), (2·12 + 3·2)/(2+3))\nP = ((12 + 3)/5, (24 + 6)/5)\nP = (15/5, 30/5)\nP = (3, 6)'
      },
      {
        id: 15,
        question: 'What is the perimeter of triangle with vertices A(0, 0), B(3, 0), and C(0, 4)?',
        options: ['12', '6', '7', '10'],
        correctAnswer: 0,
        solution: 'Find distances:\nAB = √[(3-0)² + (0-0)²] = 3\nAC = √[(0-0)² + (4-0)²] = 4\nBC = √[(0-3)² + (4-0)²] = √(9+16) = √25 = 5\n\nPerimeter = 3 + 4 + 5 = 12\n\nThis is a 3-4-5 right triangle.'
      },
      {
        id: 16,
        question: 'What is the equation of the perpendicular bisector of the segment from (2, 3) to (6, 7)?',
        options: ['y = -x + 9', 'y = x + 1', 'y = -x + 5', 'y = x - 3'],
        correctAnswer: 0,
        solution: 'Midpoint: M = ((2+6)/2, (3+7)/2) = (4, 5)\n\nSlope of segment: m₁ = (7-3)/(6-2) = 4/4 = 1\nPerpendicular slope: m₂ = -1/1 = -1\n\nEquation through (4, 5) with slope -1:\ny - 5 = -1(x - 4)\ny - 5 = -x + 4\ny = -x + 9'
      },
      {
        id: 17,
        question: 'What is the area of triangle with vertices (0, 0), (6, 0), and (3, 4)?',
        options: ['12', '24', '6', '18'],
        correctAnswer: 0,
        solution: 'Area formula: A = (1/2)|x₁(y₂-y₃) + x₂(y₃-y₁) + x₃(y₁-y₂)|\n\nA = (1/2)|0(0-4) + 6(4-0) + 3(0-0)|\nA = (1/2)|0 + 24 + 0|\nA = (1/2)(24)\nA = 12\n\nAlternatively: base = 6, height = 4, A = (1/2)(6)(4) = 12'
      },
      {
        id: 18,
        question: 'What is the x-intercept of the line 3x + 4y = 12?',
        options: ['4', '3', '12', '-4'],
        correctAnswer: 0,
        solution: 'x-intercept occurs when y = 0\n\n3x + 4(0) = 12\n3x = 12\nx = 4\n\nx-intercept: (4, 0)'
      },
      {
        id: 19,
        question: 'What is the y-intercept of the line 2x - 5y = 10?',
        options: ['-2', '2', '5', '-5'],
        correctAnswer: 0,
        solution: 'y-intercept occurs when x = 0\n\n2(0) - 5y = 10\n-5y = 10\ny = -2\n\ny-intercept: (0, -2)'
      },
      {
        id: 20,
        question: 'Points A(1, 2) and B(7, 10) are endpoints of a diameter. What is the center of the circle?',
        options: ['(4, 6)', '(8, 12)', '(3, 4)', '(6, 8)'],
        correctAnswer: 0,
        solution: 'Center is the midpoint of diameter.\n\nCenter = ((1+7)/2, (2+10)/2)\nCenter = (8/2, 12/2)\nCenter = (4, 6)\n\nThe center bisects any diameter.'
      },
      {
        id: 21,
        question: 'What is the slope of the line 4x - 2y = 8?',
        options: ['2', '-2', '4', '1/2'],
        correctAnswer: 0,
        solution: 'Convert to slope-intercept form y = mx + b:\n\n4x - 2y = 8\n-2y = -4x + 8\ny = 2x - 4\n\nSlope m = 2'
      },
      {
        id: 22,
        question: 'What is the distance from point (3, 4) to the line y = 0 (x-axis)?',
        options: ['4', '3', '5', '7'],
        correctAnswer: 0,
        solution: 'Distance from point to x-axis = |y-coordinate|\n\nPoint: (3, 4)\nDistance = |4| = 4\n\nThe perpendicular distance to y = 0 is the y-coordinate.'
      },
      {
        id: 23,
        question: 'What is the equation of a line parallel to y = 3x + 2 passing through (1, 5)?',
        options: ['y = 3x + 2', 'y = 3x + 5', 'y = 3x - 2', 'y = -1/3x + 16/3'],
        correctAnswer: 0,
        solution: 'Parallel lines have same slope: m = 3\n\nUsing point (1, 5):\ny - 5 = 3(x - 1)\ny - 5 = 3x - 3\ny = 3x + 2\n\nInterestingly, it\'s the same line!'
      },
      {
        id: 24,
        question: 'What is the radius of the circle (x-1)² + (y+2)² = 49?',
        options: ['7', '49', '√49', '14'],
        correctAnswer: 0,
        solution: 'Circle equation: (x-h)² + (y-k)² = r²\n\nComparing: r² = 49\nr = √49 = 7\n\nRadius is 7 (not 49, which is r²).'
      },
      {
        id: 25,
        question: 'What is the length of the segment from (2, 3) to (2, 9)?',
        options: ['6', '2', '√6', '12'],
        correctAnswer: 0,
        solution: 'Points have same x-coordinate (vertical segment).\n\nLength = |y₂ - y₁| = |9 - 3| = 6\n\nAlternatively: d = √[(2-2)² + (9-3)²] = √[0 + 36] = 6'
      },
      {
        id: 26,
        question: 'What is the equation of a line perpendicular to y = -2x + 5 passing through the origin?',
        options: ['y = (1/2)x', 'y = -2x', 'y = 2x', 'y = -(1/2)x'],
        correctAnswer: 0,
        solution: 'Original slope: m₁ = -2\nPerpendicular slope: m₂ = -1/(-2) = 1/2\n\nThrough origin (0, 0):\ny = (1/2)x\n\nNo y-intercept needed (passes through origin).'
      },
      {
        id: 27,
        question: 'What is the area of a circle with center (3, 4) and passing through (6, 8)?',
        options: ['25π', '5π', '√25π', '10π'],
        correctAnswer: 0,
        solution: 'Radius = distance from center to point on circle\n\nr = √[(6-3)² + (8-4)²]\nr = √[9 + 16]\nr = √25 = 5\n\nArea = πr² = π(5²) = 25π'
      },
      {
        id: 28,
        question: 'What is the slope of the line passing through (a, b) and (a, c) where b ≠ c?',
        options: ['Undefined', '0', '1', '(c-b)/0'],
        correctAnswer: 0,
        solution: 'Slope: m = (c-b)/(a-a) = (c-b)/0\n\nDivision by zero → undefined slope\n\nThis is a vertical line (same x-coordinate).'
      },
      {
        id: 29,
        question: 'What is the distance between points (5, 12) and (5, -3)?',
        options: ['15', '5', '√15', '10'],
        correctAnswer: 0,
        solution: 'Points have same x-coordinate (vertical line).\n\nDistance = |y₂ - y₁| = |(-3) - 12| = |-15| = 15\n\nAlternatively: d = √[(5-5)² + (-3-12)²] = √[0 + 225] = 15'
      },
      {
        id: 30,
        question: 'What is the equation of the line with x-intercept 4 and y-intercept -3?',
        options: ['3x - 4y = 12', '4x - 3y = 12', 'x/4 + y/(-3) = 1', 'Both A and C'],
        correctAnswer: 3,
        solution: 'Intercept form: x/a + y/b = 1\nwhere a = x-intercept, b = y-intercept\n\nx/4 + y/(-3) = 1\n\nMultiply by 12:\n3x - 4y = 12\n\nBoth forms are correct!'
      }
    ]
  }
];